import React from 'react';
import { motion } from 'framer-motion';
export interface Testimonial {
  initials: string;
  quote: string;
  name: string;
  location: string;
  role: string;
  highlight?: string;
}
interface TestimonialsSectionProps {
  title?: string;
  testimonials: Testimonial[];
  darker?: boolean;
}
export function TestimonialsSection({
  title,
  testimonials,
  darker = false
}: TestimonialsSectionProps) {
  return <section className={`cv-auto py-16 md:py-24 px-4 sm:px-6 lg:px-8 ${darker ? 'bg-navy-950' : 'bg-navy-900'}`} data-id="element-245">
      <div className="max-w-7xl mx-auto" data-id="element-246">
        {title && <motion.h2 initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.4
      }} className="text-3xl md:text-4xl lg:text-5xl font-bold text-center mb-10 md:mb-16 text-white" data-id="element-247">
            {title}
          </motion.h2>}

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-248">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-30px'
        }} transition={{
          delay: i * 0.1,
          duration: 0.4
        }} className="bg-navy-800/50 border border-purple-900/30 rounded-3xl p-6 md:p-8 flex flex-col h-full relative overflow-hidden" data-id="element-249">
              {/* Decorative glow — desktop only */}
              <div className="absolute -top-10 -right-10 w-40 h-40 bg-purple-600/10 rounded-full blur-3xl pointer-events-none hidden md:block" data-id="element-250" />

              <div className="flex items-center gap-4 mb-6 relative z-10" data-id="element-251">
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-gradient-to-br from-purple-500 to-blue-600 flex items-center justify-center text-white font-bold text-lg md:text-xl flex-shrink-0" data-id="element-252">
                  {t.initials}
                </div>
                <div data-id="element-253">
                  <div className="text-gold-400 text-sm mb-1" data-id="element-254">⭐⭐⭐⭐⭐</div>
                  {t.highlight && <span className="text-xs font-bold text-purple-300 bg-purple-900/40 px-2.5 py-1 rounded-md border border-purple-700/50" data-id="element-255">
                      {t.highlight}
                    </span>}
                </div>
              </div>

              <p className="text-slate-300 text-base md:text-lg italic mb-8 flex-grow relative z-10 leading-relaxed" data-id="element-256">
                "{t.quote}"
              </p>

              <div className="mt-auto pt-5 border-t border-navy-700/80 relative z-10" data-id="element-257">
                <p className="font-bold text-white text-base" data-id="element-258">{t.name}</p>
                <p className="text-sm text-purple-400/80 mt-0.5" data-id="element-259">
                  {t.location} · {t.role}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}